import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
export function ApplicationForm() {
  useDocumentMeta({
    title: 'Apply for Business Funding | VCA Capital Advisors',
    description: 'Apply for fast business funding from VCA Capital Advisors. $5K to $500K based on your business revenue. Quick approval with no perfect credit required.',
    path: '/application'
  });
  return <div className="min-h-screen bg-white flex flex-col font-sans" data-id="element-539">
      <Navigation data-id="element-540" />

      <main className="flex-grow pt-16 md:pt-32 px-4 sm:px-6 lg:px-8" data-id="element-541">
        <iframe src="https://form.jotform.com/VCA_Capital/vcacapitaladvisorsapplication" className="w-full border-0" style={{
        minHeight: '800px'
      }} allow="geolocation; microphone; camera; fullscreen; payment" sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-top-navigation allow-popups-to-escape-sandbox" title="VCA Capital Advisors Application" data-id="element-542" />
      </main>

      <Footer data-id="element-543" />
    </div>;
}